module.exports = __webpack_public_path__ + "static/media/richwin.7ec84eba.png";